import { render, staticRenderFns } from "./MyConfirm.vue?vue&type=template&id=4a63a7f5"
import script from "./MyConfirm.vue?vue&type=script&lang=js"
export * from "./MyConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports